import axios from 'axios';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { FaRegCircleXmark, FaRegFloppyDisk, FaRegPenToSquare } from 'react-icons/fa6';

//@ts-ignored
import 'moment/locale/fr';
import { IMeeting } from '../../../../../types';
import { IconWrapper } from '../../../../IconWrapper/IconWrapper';
import styles from './Global.module.scss';

interface IGlobalProps {
  meeting: IMeeting;
  onChange: () => void;
}

const Global = ({ meeting, onChange }: IGlobalProps) => {
  const [editMode, setEditMode] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [eventDate, setEventDate] = useState<string>('');
  const [answerBeforeDate, setAnswerBeforeDate] = useState<string>('');
  const [room, setRoom] = useState<string>('');
  const [site, setSite] = useState<string>('');
  const [street, setStreet] = useState<string>('');
  const [city, setCity] = useState<string>('');

  useEffect(() => {
    initForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting]);

  const initForm = () => {
    setName(meeting.name);
    setEventDate(meeting.event_date);
    setAnswerBeforeDate(meeting.answer_before);
    setRoom(meeting.room);
    setSite(meeting.site);
    setStreet(meeting.street);
    setCity(meeting.city);
  };

  const handleSave = () => {
    setEditMode(false);

    const updatedMeeting = {
        name,
      event_date: eventDate,
      answer_before: answerBeforeDate,
      room,
      site,
      street,
      city,
    };

    axios
      .put(`/api/meeting/${meeting._id}`, updatedMeeting)
      .then(() => {
        onChange();
      })
      .catch(() => initForm());
  };

  const handleCancel = () => {
    setEditMode(false);
    initForm();
  };

  return (
    <Card className={styles.Card}>
      <Card.Header className="d-flex justify-content-between">
        <Col sm={9}>
          {editMode ? (
            <Form.Control value={name} onChange={(event) => setName(event.target.value)} required />
          ) : (
            meeting.name
          )}
        </Col>
        <Col className="d-flex justify-content-end gap-2">
          {!editMode && (
            <Button size="sm" variant="warning" title="Edit" onClick={() => setEditMode(true)}>
              <IconWrapper icon={FaRegPenToSquare} />
            </Button>
          )}
          {editMode && (
            <ButtonGroup aria-label="Actions">
              <Button size="sm" variant="primary" onClick={handleSave} title="Save">
                <IconWrapper icon={FaRegFloppyDisk} />
              </Button>
              <Button size="sm" variant="secondary" onClick={handleCancel} title="Cancel">
                <IconWrapper icon={FaRegCircleXmark} />
              </Button>
            </ButtonGroup>
          )}
        </Col>
      </Card.Header>
      <Card.Body>
        <Row className="mb-2">
          <Col>
            <Form.Label htmlFor="event_date">Date</Form.Label>
            <Form.Control
              name="event_date"
              value={
                editMode
                  ? moment(eventDate).format('YYYY-MM-DD[T]HH[:]mm')
                  : moment(eventDate).format('LL [at] HH[:]mm')
              }
              onChange={(i) => setEventDate(i.target.value)}
              type={editMode ? 'datetime-local' : 'text'}
              readOnly={!editMode}
            />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <Form.Label htmlFor="answer_before">Response requested before</Form.Label>
            <Form.Control
              name="answer_before"
              value={
                editMode
                  ? moment(answerBeforeDate).format('YYYY-MM-DD')
                  : moment(answerBeforeDate).format('LL')
              }
              onChange={(i) => setAnswerBeforeDate(i.target.value)}
              type={editMode ? 'date' : 'text'}
              readOnly={!editMode}
            />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <Form.Label htmlFor="room">Room</Form.Label>
            <Form.Control
              name="room"
              value={room}
              onChange={(i) => setRoom(i.target.value)}
              readOnly={!editMode}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Label htmlFor="site">Site</Form.Label>
            <Form.Control
              name="site"
              value={site}
              onChange={(i) => setSite(i.target.value)}
              readOnly={!editMode}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Label htmlFor="street">Street</Form.Label>
            <Form.Control
              name="street"
              value={street}
              onChange={(i) => setStreet(i.target.value)}
              readOnly={!editMode}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Label htmlFor="city">City</Form.Label>
            <Form.Control
              name="city"
              value={city}
              onChange={(i) => setCity(i.target.value)}
              readOnly={!editMode}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Global;
